import React, { createContext, useContext, useState, useMemo } from 'react';

const TabbedFormContext = createContext()

export const useTabbedForm = () => useContext(TabbedFormContext)

const initEmpty = tabs => {
  if (!!tabs) {
    tabs.reduce((acc, cur) => acc[cur.key] = {}, {})
  }
  return {}
}

export const TabbedFormProvider = ({ tabs, children }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [formData, setCtxFormData] = useState(initEmpty(tabs))
  const [submitAttempted, setSubmitAttempted] = useState(false)

  const tabKeys = tabs.map(tab => tab.key)

  const setFormData = (data, tabKey) => {
    if (!!tabKey) // no tabKey provided. set for current tab.
      tabKey = tabs[activeTab].key
    setCtxFormData({
      ...formData,
      [tabKey]: data
    })
  }

  const filteredTabs = useMemo(() => tabs.filter(tab =>!(typeof tab.hidden === 'function' && tab.hidden(formData?.undefined))),
    [tabs, formData]
  )

  return <TabbedFormContext.Provider value={{
    tabKeys, filteredTabs,
    formData, setFormData,
    activeTab, setActiveTab,
    isLastTab: activeTab === filteredTabs.length - 1,
    isTabbedForm: true,
    submitAttempted, attemptSubmit: () => setSubmitAttempted(true)
  }}>
    {children}
  </TabbedFormContext.Provider>

}